import { render, staticRenderFns } from "./PanelResizer.vue?vue&type=template&id=79a6d0c6&scoped=true&"
import script from "./PanelResizer.vue?vue&type=script&lang=js&"
export * from "./PanelResizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a6d0c6",
  null
  
)

export default component.exports